// Mock data for Ybera USA clone (no cart, all links carry affiliate code)
export const OFFICIAL_URL = "https://ybera.us";
export const AFFILIATE_CODE = "8479159";
export const aff = (path = "/") => `${OFFICIAL_URL}${path}?p=${AFFILIATE_CODE}`;

export const WHATSAPP_GROUP = "https://chat.whatsapp.com/FsIefnAdBDxDyjpgnwRFK1?mode=gi_t";
export const WHATSAPP_AFFILIATE = "https://wa.me/5513981675693?text=Hi!%20I%27d%20love%20to%20become%20a%20Ybera%20affiliate.";

// WhatsApp group social proof
export const GROUP_MEMBERS = "2,500+";
export const groupClients = [
  "https://ybera.us/cdn/shop/files/f12.png?v=1747306022",
  "https://ybera.us/cdn/shop/files/section-after_87b6c13e-bf07-463b-b6b3-8f7acaaefa7d.png?v=1745355306",
  "https://ybera.us/cdn/shop/files/02_hair-problem.webp?v=1747147381",
  "https://ybera.us/cdn/shop/files/01_hair-problem.webp?v=1747147381",
  "https://ybera.us/cdn/shop/files/03_hair-problem.webp?v=1747147381",
];

export const announcements = [
  "ELEVATE YOUR HAIR. ELEVATE YOUR CONFIDENCE!",
  "FREE SHIPPING on orders over $50",
  "JOIN OUR WHATSAPP GROUP FOR EXCLUSIVE DROPS",
];

export const navLinks = [
  { label: "Shop", href: aff("/collections/all") },
  { label: "Fashion Gold", href: aff("/collections/fashion-gold") },
  { label: "Mirra", href: aff("/collections/mirra") },
  { label: "Vello", href: aff("/collections/vello-1") },
  { label: "Cronograma", href: aff("/collections/cronograma-hair-care-system") },
  { label: "Our Story", href: aff("/pages/our-story") },
];

export const heroSlides = [
  {
    id: 1,
    img: "https://ybera.us/cdn/shop/files/Banner_Off_2-30_Set_3.png?v=1788464771&width=1600",
    title: "UP TO 30% OFF",
    subtitle: "Signature Brazilian Hair Care",
    cta: "Shop the Sale",
    href: aff("/collections/all"),
  },
  {
    id: 2,
    img: "https://ybera.us/cdn/shop/files/Banner_Cronograma_New_b1.png?v=1789496469&width=1600",
    title: "CRONOGRAMA",
    subtitle: "The full at-home hair care ritual",
    cta: "Discover Cronograma",
    href: aff("/collections/cronograma-hair-care-system"),
  },
  {
    id: 3,
    img: "https://ybera.us/cdn/shop/files/Banner_Campanha_Vello_2.752_x_660_px.png?v=1790350959&width=1600",
    title: "VELLO GROWTH",
    subtitle: "Fortify roots. Awaken new growth.",
    cta: "Explore Vello",
    href: aff("/collections/vello-1"),
  },
];

export const marqueeReviews = [
  '"My hair is so healthy and shining. Love these products." — Rosana Barbosa',
  '"I loved this progressive! Approved." — Jessica Burgio',
  '"It arrived on time. Packed and sealed. Great condition." — Michele',
  '"It\'s the best thing, like food for your hair! Will buy again." — Chelsea Ferreira',
  '"Really good product, I always used high quality masks on my hair." — Tatiana',
];

export const bestSellers = [
  {
    id: "vello-kit",
    name: "Vello Strengthening Hair Kit | Special Price",
    brand: "Ybera USA",
    price: 99.9,
    compareAt: 146.9,
    off: "32% Off",
    tag: "Special Offer",
    img: "https://ybera.us/cdn/shop/files/SHAMPOO_MASCARA_TONICO_VELLO.png?v=1752853641&width=800",
    rating: 5.0,
    href: aff("/products/vello-strengthening-hair-kit-special-price"),
  },
  {
    id: "deep-care",
    name: "Deep Care Kit – Ybera Fashion Gold",
    brand: "Ybera USA",
    price: 69.9,
    compareAt: 89.9,
    off: "22% Off",
    img: "https://ybera.us/cdn/shop/files/Artboard_1_62a39a8d-9dfe-4cdc-9bfd-7626a71076ab.png?v=1789475859",
    hoverImg: "https://ybera.us/cdn/shop/files/DSC09878.jpg?v=1789476026",
    rating: 5.0,
    href: aff("/products/deep-care-kit-ybera-fashion-gold"),
  },
  {
    id: "fashion-gold-300",
    name: "FASHION GOLD 300g / 10.5oz – Brazilian Keratin Treatment",
    brand: "Ybera USA",
    price: 59.9,
    compareAt: 77.9,
    off: "23% Off",
    img: "https://ybera.us/cdn/shop/files/149.jpg?v=1770436510",
    hoverImg: "https://ybera.us/cdn/shop/files/04_PDP_Progressiva_Escoba_fashion-Gold_2025_bcbb8cd6-2dab-407e-a598-4b896ae3dc08.jpg?v=1770435794",
    rating: 4.9,
    href: aff("/products/progressiva-300g"),
  },
  {
    id: "myrrh-oil",
    name: "MYRRH HAIR REPAIR OIL 90ml / 3fl.oz – YBERA PARIS",
    brand: "Ybera Paris",
    price: 69.9,
    compareAt: 79.9,
    off: "13% Off",
    img: "https://ybera.us/cdn/shop/files/139.jpg?v=1770435790",
    hoverImg: "https://ybera.us/cdn/shop/files/Artboard_34.png?v=1770670496",
    rating: 5.0,
    href: aff("/products/mirra-oil-90ml"),
  },
  {
    id: "perfect-straight",
    name: "Perfect Straight Hair Care Kit – Ybera Fashion Gold",
    brand: "Ybera USA",
    price: 69.0,
    compareAt: 88.0,
    off: "22% Off",
    img: "https://ybera.us/cdn/shop/files/29.jpg?v=1770319181",
    hoverImg: "https://ybera.us/cdn/shop/files/6517b9fe-cb35-4a6d-8fd9-cf3efc2f4dd4_a26266fa-cf88-4fff-9969-61cbfbf48ca6.jpg?v=1766515202",
    rating: 4.8,
    href: aff("/products/perfect-straight-hair-care-kit-smoothness-strength-anti-frizz-control-ybera-fashion-gold-1"),
  },
];

export const hairProblems = [
  { title: "Damaged Hair", img: "https://ybera.us/cdn/shop/files/02_hair-problem.webp?v=1747147381", href: aff("/collections/dullness") },
  { title: "Frizz Control & Dry Hair", img: "https://ybera.us/cdn/shop/files/01_hair-problem.webp?v=1747147381", href: aff("/collections/dryness-frizz") },
  { title: "Hair Loss / Thinning", img: "https://ybera.us/cdn/shop/files/04_hair-problem.webp?v=1747147381", href: aff("/collections/hair-loss-thinning-hair") },
  { title: "Undefined Curls", img: "https://ybera.us/cdn/shop/files/03_hair-problem.webp?v=1747147381", href: aff("/collections/frizz-lack-of-volume") },
];

export const testimonials = [
  { name: "Livia Mara Carvalho", text: "I am truly thrilled with the results—silky, shiny, straight hair. I highly recommend it." },
  { name: "Liliam Santos", text: "I love these products! Great quality, leaves my hair soft, hydrated, and looking much healthier. Highly recommend!" },
  { name: "Paola A.", text: "The best shampoo to control oily hair and keep the scalp clean." },
  { name: "LeanysC", text: "I love how it leaves my hair and the smell. Such a great product." },
  { name: "Mary", text: "Excellent products—I can already see a slight change in my hair. I definitely recommend them." },
  { name: "Customer", text: "Was excited to try Ybera products. The delivery was really fast." },
];

export const beforeAfter = [
  {
    title: "I loved this Progressiva Keratin Treatment!",
    author: "Jessica B.",
    quote: "I have a lot of hair, and this treatment really helped reduce the volume and made it easier to blow-dry.",
    beforeImg: "https://ybera.us/cdn/shop/files/f11.png?v=1747306022",
    afterImg: "https://ybera.us/cdn/shop/files/f12.png?v=1747306022",
    leftLabel: "Before",
    rightLabel: "After",
    collection: "Fashion Gold",
    href: aff("/collections/fashion-gold"),
  },
  {
    title: "Amazing product, Cronograma!",
    author: "Chelsea F.",
    quote: "It leaves your hair feeling hydrated, soft, and beautifully shiny. Highly recommend for anyone looking to enhance their hair's health and appearance!",
    beforeImg: "https://ybera.us/cdn/shop/files/section-before_60069dca-912a-4902-844f-85b6df85878c.png?v=1745355306",
    afterImg: "https://ybera.us/cdn/shop/files/section-after_87b6c13e-bf07-463b-b6b3-8f7acaaefa7d.png?v=1745355306",
    leftLabel: "Week 1",
    rightLabel: "Week 9",
    collection: "Hair Care System",
    href: aff("/collections/cronograma-hair-care-system"),
  },
];

export const collections = [
  { title: "Fashion Gold", img: "https://ybera.us/cdn/shop/files/Prancheta_1.png?v=1775584374", href: aff("/collections/fashion-gold") },
  { title: "Mirra", img: "https://ybera.us/cdn/shop/files/Prancheta_4.png?v=1775584396", href: aff("/collections/mirra") },
  { title: "Vello", img: "https://ybera.us/cdn/shop/files/Prancheta_3.png?v=1775584395", href: aff("/collections/vello-1") },
  { title: "Cronograma", img: "https://ybera.us/cdn/shop/files/Prancheta_2.png?v=1775584396", href: aff("/collections/cronograma-hair-care-system") },
];

export const recentReviews = [
  { title: "Amazing Hair Transformation!", author: "Dayane Graziani", product: "MYRRH HAIR REPAIR OIL 90ml – YBERA PARIS", date: "12/25/2025", text: "From the very first use my hair felt noticeably softer, smoother, and more nourished. Lightweight yet incredibly hydrating.", img: "https://cdn.shopify.com/s/files/1/0643/8590/8810/files/MIRRA_COM_CANNISTER_160x160.png?v=1750724235" },
  { title: "It delivers what it promises!", author: "Rosana Beserra", product: "VELLO Hair Fertilization Therapy – Ybera Paris", date: "12/25/2025", text: "My husband has used it for a year — it's perfect and truly delivers.", img: "https://cdn.shopify.com/s/files/1/0643/8590/8810/files/YBERA_PARIS_-_vello_-_Soro_Vital_alfa-lactobaby_-_90ml_1_160x160.png?v=1770237153" },
  { title: "Responsibility and great service", author: "Marggi Barajas", product: "Kit TERRA COCO Isotonic Shampoo + Coconut Mask + Elixir", date: "12/24/2025", text: "Responsibility and excellent service.", img: "https://cdn.shopify.com/s/files/1/0643/8590/8810/files/kit_tratamento_terra_coco_elixir_160x160.png?v=1770236508" },
  { title: "Loved it for my daughter", author: "Nataniela", product: "Girls' Hair Care Kit – Ybera Fashion Kids", date: "12/23/2025", text: "I'm using it on my 1-year-old daughter's hair and it looks more beautiful every day.", img: "https://cdn.shopify.com/s/files/1/0643/8590/8810/files/5d162628-e9e7-4c2c-b99c-d51062cb59c1_160x160.jpg?v=1766091883" },
  { title: "Been using it for a long time", author: "Nataniela", product: "Double Care – CRONOGRAMA Hair Care System", date: "12/23/2025", text: "I love it — I've been using it for a long time.", img: "https://cdn.shopify.com/s/files/1/0643/8590/8810/files/Off1_August_29-30-11_1_160x160.png?v=1787840564" },
  { title: "Great scent", author: "Paola", product: "Floral Fusion Hair Mist 50ml", date: "12/19/2025", text: "Amazing product, smells very good!", img: "https://cdn.shopify.com/s/files/1/0643/8590/8810/files/HairMist-FLORALFUSION_d9d86917-8f6b-46c0-98ec-3b8222991fe9_160x160.png?v=1750357813" },
];

export const TIKTOK_PROFILE = "https://www.tiktok.com/@ybera.us";
export const tiktokVideos = [
  { id: "7526900929564593414", handle: "@ybera.club" },
  { id: "7504345451013885189", handle: "@naymazetto" },
  { id: "7375256630319009029", handle: "@dicasdecabelosdadani" },
  { id: "7500407645694725382", handle: "@srh_daily" },
  { id: "7494485536631950597", handle: "@theskah" },
  { id: "7401956626338548998", handle: "@sthe.souuza" },
  { id: "7211910699574938886", handle: "@ericamarquesss" },
  { id: "7511803415618473221", handle: "@maricristna" },
  { id: "7447998168765172997", handle: "@samysssoares" },
  { id: "7493208603545980215", handle: "@naymazetto" },
  { id: "7150842193312271622", handle: "@marla.honorato" },
  { id: "7498707249544662302", handle: "@hairstylistqueen1" },
];

export const blogPosts = [
  { title: "Is Keratin Good For Hair? Pros, Cons, And Myths", img: "https://ybera.us/cdn/shop/articles/Is_Keratin_Good_For_Hair.png?v=1768312175", excerpt: "What makes Ybera's approach safe, effective, and different.", href: aff("/blogs/haircare/is-keratin-good-for-hair") },
  { title: "How Long Does A Keratin Treatment Last? Timeline", img: "https://ybera.us/cdn/shop/articles/How_Long_Does_Keratin_Treatment_Last.png?v=1768312701", excerpt: "Expert insight from Ybera on treatment timelines and hair care.", href: aff("/blogs/haircare/how-long-does-keratin-treatment-last") },
  { title: "Does Keratin Treatment Damage Hair? The Truth", img: "https://ybera.us/cdn/shop/articles/Does_Keratin_Treatment_Damage_Hair.png?v=1768313719", excerpt: "Ybera answers the real concerns and explains professional application.", href: aff("/blogs/haircare/does-keratin-treatment-damage-hair") },
];

export const badges = ["Cruelty Free", "Vegan", "Paraben Free", "Sulfate Free", "Formaldehyde Free"];
